Array.prototype.unique = function() {
    return [... new Set(this)];
 };

 Array.prototype.hasIntersectionWith = function(arr) {
     const intersection = this.filter(item => arr.includes(item));
     return intersection.length !== 0;
 }